import { appValueTypes } from "../../types/types";

export const defaultAppInputValues:appValueTypes = {
    appBuildType:{
      "name": "appBuildType",
      "type": "string",
      "value": '',
      "docUrl": "",
      "description": "android app last build Id of completed build",
      "possibleVals": [
      'string'
      ]
    },
    iosAppId:{
      "name": "iosAppId",
      "type": "string",
      "value": '',
      "docUrl": "",
      "description": "android app last build Id of completed build",
      "possibleVals": [
      'string'
      ]
    },
    androidAppId:{
      "name": "androidAppId",
      "type": "string",
      "value": '',
      "docUrl": "",
      "description": "android app last build Id of completed build",
      "possibleVals": [
      'string'
      ]
    },
    appBuildId:{
      "name": "appBuildId",
      "type": "string",
      "value": '',
      "docUrl": "",
      "description": "android app last build Id",
      "possibleVals": [
        'string'
      ]
    },
    loadingBackgroundImage: {
        "name": "loadingBackgroundImage",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Loading page background image",
        "possibleVals": [
          "string"
        ]
    },
    clientLogo: {
        "name": "clientLogo",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Client Logo",
        "possibleVals": [
          "string"
        ]
    },
    poweredByLogo: {
        "name": "poweredByLogo",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Client Logo",
        "possibleVals": [
          "string"
        ]
    },
    clientHeaderLogo: {
        "name": "clientHeaderLogo",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Client Header Logo",
        "possibleVals": [
          "string"
        ]
    },
    appIcon: {
        "name": "appIcon",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "App Icon",
        "possibleVals": [
          "string"
        ]
    },
    appName: {
        "name": "appName",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "App Name",
        "possibleVals": [
          "string"
        ]
    },
    isAppOffline: {
        "name": "isAppOffline",
        "type": "string",
        "value": false,
        "docUrl": "",
        "description": "whether the app is OnLineApp or OfflineApp",
        "possibleVals": [
          true, false
        ]
    },
    clientLogoHeight: {
        "name": "clientLogoHeight",
        "type": "number",
        "value": 80,
        "docUrl": "",
        "description": "Logo Height",
        "possibleVals": [
          "number"
        ]
    },
    clientHeaderLogoHeight: {
        "name": "clientHeaderLogoHeight",
        "type": "number",
        "value": 20,
        "docUrl": "",
        "description": "Logo Height",
        "possibleVals": [
          "number"
        ]
    },
    loginBanner:{
        "name": "loginBanner",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "login banner",
        "possibleVals": [
          "string"
        ]
    },
    appBarBackgroundType:{
        "name": "appBarBackgroundType",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "used to change the appbar background type",
        "possibleVals": ['solid', 'gradient', 'image']
    },
    solidAppBarColor:{
        "name": "solidAppBarColor",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Appbar background image",
        "possibleVals": [
          "string"
        ]
    },
    gradientAppBarColor:{
        "name": "gradientAppBarColor",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Appbar background image",
        "possibleVals": [
          "string"
        ]
    },
    appbarBackgroundImage:{
        "name": "appbarBackgroundImage",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Appbar background image",
        "possibleVals": [
          "string"
        ]
    },
    loadingScreenText:{
        "name": "loadingScreenText",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Loading Screen Text",
        "possibleVals": [
          "string"
        ]
    },
    loaderGIF:{
        "name": "loaderGIF",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Loader GIF",
        "possibleVals": [
          "string"
        ]
    },
    appPackageName:{
        "name": "appPackageName",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "App Package Name",
        "possibleVals": [
          "string"
        ]
    },
    iosAppPackageName:{
        "name": "iosAppPackageName",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "App Package Name",
        "possibleVals": [
          "string"
        ]
    },
    psLink:{
        "name": "psLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "PS Link",
        "possibleVals": [
          "string"
        ]
    },
    appStoreLink:{
        "name": "appStoreLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "PS Link",
        "possibleVals": [
          "string"
        ]
    },
    moengageKey:{
        "name": "moengageKey",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Moengage Key",
        "possibleVals": [
          "string"
        ]
    },
    privacyPolicyValidation:{
        "name": "privacyPolicyValidation",
        "type": "boolean",
        "value": false,
        "docUrl": "",
        "description": "Privacy Policy Validation",
        "possibleVals": [
          true, false
        ]
    },

    isSuggestProductToBeShown:{
        "name": "isSuggestProductToBeShown",
        "type": "boolean",
        "value": false,
        "docUrl": "",
        "description": "show suggested products on homescreen",
        "possibleVals": [
          true, false
        ]
    },
    deepLinkUrl:{
        "name": "deepLinkUrl",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Deep Link Url",
        "possibleVals": [
          "string"
        ]
    },
    shareText:{
        "name": "shareText",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Share Text",
        "possibleVals": [
          "string"
        ]
    },
    slackAlertChannel:{
        "name": "slackAlertChannel",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "slack alert channel link",
        "possibleVals": [
          "string"
        ]
    },
    themeColor:{
      "name": "themeColor",
      "type": "string",
      "value": "#ff0000",
      "docUrl": "",
      "description": "theme color",
      "possibleVals": [
        "string"
      ]
    },
}